module.exports = __webpack_public_path__ + "dd298cad262dc33d5049c91284fc3278.png";